/**
 * @generated SignedSource<<8c9f249b65fba9e6fcdb5381b00c6479>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompaniesTableRow_company$data = {
  readonly id: string;
  readonly rowId: any;
  readonly name: string;
  readonly legalName: string | null;
  readonly createdAt: any;
  readonly deletedAt: any | null;
  readonly reports: {
    readonly totalCount: number;
  };
  readonly reportMetrics: ReadonlyArray<{
    readonly name: string;
    readonly value: number | null;
  } | null>;
  readonly organization: {
    readonly organizationSubscriptions: {
      readonly nodes: ReadonlyArray<{
        readonly currentPeriodEnd: any | null;
        readonly billingPlan: {
          readonly slug: string;
        } | null;
      }>;
    };
  } | null;
  readonly " $fragmentType": "CompaniesTableRow_company";
};
export type CompaniesTableRow_company$key = {
  readonly " $data"?: CompaniesTableRow_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompaniesTableRow_company">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompaniesTableRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "legalName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportsConnection",
      "kind": "LinkedField",
      "name": "reports",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportMetricResult",
      "kind": "LinkedField",
      "name": "reportMetrics",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationSubscriptionsConnection",
          "kind": "LinkedField",
          "name": "organizationSubscriptions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationSubscription",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currentPeriodEnd",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BillingPlan",
                  "kind": "LinkedField",
                  "name": "billingPlan",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "d11b248e4e514f67fdeed8cf0a6c67f2";

export default node;
